// AppButton.jsx
import React from "react";
import { Button } from "reactstrap";
import useTheme from "../../helpers/useTheme";

const AppButton = ({
  text = "Submit",
  size = "sm",
  type = "button",
  color, // Custom background color
  children,
  textColor = "#fff", // Default text color
  className = "",
  borderColor,
  borderRadius,
  fontSize,
  ...rest
}) => {
  const {
    // color: themeColor = {},
    // bgColor,
    // tertiaryColor,
    primaryColor,
  } = useTheme();

  // Determine the button's background color — always prefer tenant brand.
  const buttonBackgroundColor =
    color || primaryColor || "var(--brand, var(--rv-primary))";

  // Define the style object
  const buttonStyle = {
    fontSize: fontSize || "14px",
    borderRadius: borderRadius || "10px",
    fontFamily: "Vastago Grotesk, sans-serif",
    color: textColor,
    backgroundColor: buttonBackgroundColor,
    borderColor: borderColor ? borderColor : buttonBackgroundColor,
  };

  return (
    <Button
      type={type}
      size={size}
      className={className}
      style={buttonStyle}
      {...rest}
    >
      {children || text}
    </Button>
  );
};

export default AppButton;
